export default class DtoBoreholeLithologyItem {
    constructor(obj) {
        this.lithologyCode = obj.lithologyCode
        this.order = obj.order
        this.thickness = obj.thickness
        this.comment = obj.comment
        this.depth = obj.depth
        this.headers = ['depth', 'comment']
    }
}